import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';
export const getOneGroupDetail = async (id) => {
  //   const authState = getAuthenticationState();
  try {
    if (!id) {
      return;
    }
    const resp = await apiClient.get(`/users/userAssignmentDetails/${id}`, {
      // headers: {
      //   authorization: `Bearer ${authState.token}`
      // }
    });

    return resp.data;
  } catch (error) {
    handleApiError(error);
  }
};
